import { createAction, props } from '@ngrx/store';
import { SimXTaxonomyTerm } from '../../../shared/models/entities/simx-taxonomy-term.model';

export enum ActionTypes {
  RequestTaxonomyTerms = '[Taxonomy] Request Taxonomy Terms',
  FetchTaxonomyTerms = '[Taxonomy] Fetch Taxonomy Terms',
  FetchTaxonomyTermsSucceeded = '[Taxonomy] Fetch Taxonomy Terms Succeeded',
  FetchTaxonomyTermsFailed = '[Taxonomy] Fetch Taxonomy Terms Failed',
  ResetTaxonomyStore = '[Taxonomy] Reset Taxonomy Store',
}

export const requestTaxonomyTerms = createAction(
  ActionTypes.RequestTaxonomyTerms,
);
export const fetchTaxonomyTerms = createAction(ActionTypes.FetchTaxonomyTerms);
export const fetchTaxonomyTermsSucceeded = createAction(
  ActionTypes.FetchTaxonomyTermsSucceeded,
  props<{ taxonomyTerms: Array<SimXTaxonomyTerm> }>(),
);
export const fetchTaxonomyTermsFailed = createAction(
  ActionTypes.FetchTaxonomyTermsFailed,
);
export const resetTaxonomyStore = createAction(ActionTypes.ResetTaxonomyStore);
